import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { Projectmember } from '../model/projectmember';

@Injectable({
  providedIn: 'root'
})
export class OrgprojectmemberlistService {

  constructor(private http:HttpClient) { }
  

  saveMember(member:Projectmember){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<Projectmember[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/projectperson/"+member.projectId+"/person/"+member.personId,member,httpOptions)
  
  }
  deleteMember(member:Projectmember){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/projectperson/"+member.projectId+"/person/"+member.personId,httpOptions)
  
  }
}
